// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1U6r0","content":"styles_content__1RKlf"};